import { render } from "./WagoEnergyHeatmap.vue?vue&type=template&id=4cb0f94c&scoped=true&ts=true"
import script from "./WagoEnergyHeatmap.vue?vue&type=script&lang=ts"
export * from "./WagoEnergyHeatmap.vue?vue&type=script&lang=ts"

import "./WagoEnergyHeatmap.vue?vue&type=style&index=0&id=4cb0f94c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb0f94c"]])

export default __exports__